import { render, staticRenderFns } from "./upBtn.vue?vue&type=template&id=e9eda2a2&scoped=true&"
import script from "./upBtn.vue?vue&type=script&lang=js&"
export * from "./upBtn.vue?vue&type=script&lang=js&"
import style0 from "./upBtn.vue?vue&type=style&index=0&id=e9eda2a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9eda2a2",
  null
  
)

export default component.exports